// extracted by mini-css-extract-plugin
module.exports = {"main":"Privacy_main__2sCtN"};